export default __webpack_public_path__ + "static/media/layout-grid-16.516da8ef.svg";